var _style, _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.9 50",
    style: {
      enableBackground: "new 0 0 39.9 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000091005890640804452740000007892819137887088785_);}\r\n\t.st1{fill:#777777;}\r\n\t.st2{enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1922",
    transform: "translate(-1257 -619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    transform: "translate(1257 619)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 39.9,
    height: 50
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026881904264731158340000008195505121988604856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1920-2",
    style: {
      clipPath: "url(#SVGID_00000026881904264731158340000008195505121988604856_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,49.6c-0.2,0-0.4-0.1-0.5-0.2l-1.9-1.2c-1.6-1-9.4-6.2-12.2-8.3c-3.2-2.6-5.1-6.6-4.9-10.8l0-19.8 c0-0.6,0.4-1,1-1c8,0,17.8-7.6,17.9-7.6c0.4-0.3,0.9-0.3,1.2,0c0.1,0.1,9.9,7.6,17.9,7.6c0.6,0,1,0.4,1,1v19.9 c0.1,4.1-1.7,8.1-4.9,10.7c-2.9,2.1-11.3,7.7-12.2,8.3l-1.9,1.2C20.4,49.5,20.2,49.6,20,49.6z M2.4,10.2v18.9 c-0.1,3.5,1.4,7,4.2,9.2c2.7,2,10.5,7.2,12.1,8.2l1.3,0.9l1.3-0.9c1-0.6,9.3-6.1,12.1-8.2c2.7-2.2,4.2-5.6,4.1-9.1l0-19 C30.2,9.8,22.2,4.3,20,2.7C17.7,4.3,9.7,9.8,2.4,10.2z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1278.6,653.9c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.3l-6.7-7.8c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.1-0.1-0.2-0.1-0.4v-0.3c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2h1.7c1.4,0,2.5-0.2,3.2-0.5 c0.7-0.4,1.2-0.8,1.5-1.4c0.3-0.6,0.4-1.3,0.4-2c0-0.7-0.1-1.4-0.4-2c-0.3-0.6-0.8-1.1-1.5-1.4c-0.7-0.4-1.7-0.5-2.9-0.5h-2.3 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4V635c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2h10.8c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.3,0.2,0.4v0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2h-4.1l-1.3-0.8c1.3,0.3,2.3,0.8,2.8,1.7 c0.5,0.9,0.8,1.9,0.8,3.1c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1.1,1.5-2,2c-0.9,0.5-2.2,0.8-3.8,0.8h-0.7l-0.2-0.7l7.1,8.3 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1-0.1,0.3-0.2,0.3c-0.1,0.1-0.2,0.1-0.4,0.1H1278.6z M1271.1,640.5c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.1-0.2-0.3-0.2-0.4v-0.4c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2h10.8c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.3,0.2,0.4v0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2H1271.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPremium);
export default __webpack_public_path__ + "static/media/business-premium.4b682d5c46a850fc85a127f7a22cc172.svg";
export { ForwardRef as ReactComponent };